import React from "react";
import "./SplashScreen.css"; // کدهای CSS بخش بالا را در این فایل قرار دهید.

export default function SplashScreen() {
  return (
    <div className="pwa-splash-container">
      <div className="pwa-splash-glass">
        <div className="pwa-logo-wrapper" style={{ opacity: 1 }}>
          <img 
            src="/logo.png" 
            alt="الف" 
            className="pwa-splash-logo" 
            onError={(e) => { e.target.src = "/logo192.png"; }}
          />
        </div>

        <div className="pwa-text-wrapper" style={{ opacity: 1 }}>
          <h1 className="pwa-splash-title">اَلِـف</h1>
          <p className="pwa-splash-subtitle">سامانه هوشمند آموزشی و هدایت تحصیلی</p>
        </div>

        <div className="pwa-loader-container" style={{ opacity: 1 }}>
          <div className="pwa-glowing-spinner">
            <div className="pwa-inner-ring"></div>
          </div>
          <span className="pwa-loading-text">در حال بارگذاری اطلاعات...</span>
        </div>
      </div>
    </div>
  );
}
